import React, { useState } from 'react';

// router
import Router from './router/Router';

// scss
import "./scss/main.scss";

// scroll
import ScrollToTop from "./components/scroll/ScrollToTop";
// import CookiePopUp from './components/cookie/CookiePopUp';



function App() {

  const [cookie, setCookie] = useState(true);

  return (
    <div>
      <ScrollToTop />
      <Router />
      {/* {cookie && <CookiePopUp setCookie={setCookie}/>} */}
    </div>
  );
}

export default App;
